export default {
  methods: {
    bookingTncLink () {
      if (this.booking && this.booking.region && this.booking.region.shortname === 'gb') {
        return 'https://pickstar.pro/Terms_of_Talent_Booking_TCs_2022_GB.pdf' // TODO: there is a separate task to refactor tnc PIC-1603
      }
      return 'https://pickstar.pro/au/policies/terms-conditions'
    },
    regAgreementLink () {
      if (this.booking && this.booking.region && this.booking.region.shortname === 'gb') {
        return 'https://pickstar.pro/Pickstar_Talent_Manager_Registration_TCs_2022_GB.pdf'
      }
      return 'https://pickstar.pro/Pickstar_Talent_Manager_Registration_TCs_2022_AU.pdf'
    }
  }
}
